import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Layout = ({ children }) => {
  const location = useLocation();
  const isAttorneyRoute = location.pathname.startsWith('/attorney');

  return (
    <div className="min-h-screen flex flex-col">
      {/* Header */}
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center space-x-2">
              <div className="w-10 h-10 bg-gradient-to-r from-primary-500 to-secondary-500 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-xl">TB</span>
              </div>
              <span className="text-xl font-bold bg-gradient-to-r from-primary-500 to-secondary-500 bg-clip-text text-transparent">
                TensionBridge ADR
              </span>
            </Link>

            {!isAttorneyRoute && (
              <div className="text-sm text-gray-600">
                <span className="hidden sm:inline">Dispute Resolution • </span>
                <span>Up to €15,000</span>
              </div>
            )}

            {isAttorneyRoute && (
              <nav className="flex space-x-4">
                <Link
                  to="/attorney/dashboard"
                  className={`px-3 py-2 rounded-md text-sm font-medium ${
                    location.pathname === '/attorney/dashboard'
                      ? 'bg-primary-100 text-primary-700'
                      : 'text-gray-700 hover:bg-gray-100'
                  }`}
                >
                  Dashboard
                </Link>
                <Link
                  to="/attorney/analytics"
                  className={`px-3 py-2 rounded-md text-sm font-medium ${
                    location.pathname === '/attorney/analytics'
                      ? 'bg-primary-100 text-primary-700'
                      : 'text-gray-700 hover:bg-gray-100'
                  }`}
                >
                  Analytics
                </Link>
              </nav>
            )}
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1">
        {children}
      </main>

      {/* Footer */}
      {!isAttorneyRoute && (
        <footer className="bg-gray-50 border-t border-gray-200 mt-auto">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
            <div className="text-center text-sm text-gray-600">
              <p className="mb-2">
                © {new Date().getFullYear()} TensionBridge ADR™ • Alternative Dispute Resolution Platform
              </p>
              <p className="text-xs text-gray-500">
                Confidential • Private • Attorney-Reviewed
              </p>
            </div>
          </div>
        </footer>
      )}
    </div>
  );
};

export default Layout;
